import React from 'react';
import {
  color,
  viChevronRight,
  VibeIcon,
} from 'vibeguide';

function CustomRightArrow({
  onClick,
}) {
  return (
    <div className="loop-right-button" onClick={() => onClick()}>
      <VibeIcon
        icon={viChevronRight}
        color={color.white}
        size={34}
      />
    </div>
  );
}

export default CustomRightArrow;
